module.exports = __webpack_public_path__ + "img/playbar_next.62a69d90.svg";